"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalizeFactory = exports.externalizeProcessedFactory = exports.externalizeFactory = exports.skipFailedFactory = exports.retryFailedFactory = exports.sendFactory = void 0;
const abortable_fetch_1 = require("../../../../utils/abortable-fetch");
function sendFactory(url) {
    return function send() {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/send`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.sendFactory = sendFactory;
function retryFailedFactory(url) {
    return function send() {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/retry-failed`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.retryFailedFactory = retryFailedFactory;
function skipFailedFactory(url) {
    return function send() {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/skip-failed`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.skipFailedFactory = skipFailedFactory;
function externalizeFactory(api) {
    return function externalize(id) {
        return (0, abortable_fetch_1.abortableFetch)(`${api}/${id}/externalize`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.externalizeFactory = externalizeFactory;
function externalizeProcessedFactory(url) {
    return function externalizeProcessed() {
        return (0, abortable_fetch_1.abortableFetch)(`${url}/externalize-processed`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.externalizeProcessedFactory = externalizeProcessedFactory;
function internalizeFactory(api) {
    return function internalize(id) {
        return (0, abortable_fetch_1.abortableFetch)(`${api}/${id}/internalize`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.internalizeFactory = internalizeFactory;
//# sourceMappingURL=batches-api.js.map